import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { HStack } from "@/components/layout/HStack";
import { useEffect, useState } from "react";
import { useExplorations } from "../hooks/browseExplorations/useExplorations";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/Button/Button";
import { Link } from "react-router-dom";
import { BrowseExplorations } from "../components/browseExplorations/BrowseExplorations";
import { ArchiveToggleButton } from "@/components/elements/ArchiveToggleButton/ArchiveToggleButton";

const TeacherBrowseExplorations = ({
  archived = false,
}: {
  archived?: boolean;
}) => {
  const [explorations, setExplorations] = useState<{
    explorations: any[];
    rotations: any[];
    sessions: any[];
    teachers: any[];
  }>({
    explorations: [],
    rotations: [],
    sessions: [],
    teachers: [],
  });

  const { loadExplorations, loading } = useExplorations({ archived });

  useEffect(() => {
    loadExplorations(setExplorations);
  }, [archived]);

  return (
    <Dashboard activePage={archived ? "/explorations/archive" : "/explorations"}>
      <HStack justify="space-between" wrap>
        <VStack>
          <h2
            style={{
              fontSize: "var(--text-2xl)",
              lineHeight: "var(--line-height-2xl)",
              fontWeight: "var(--font-bold)",
            }}
          >
            {archived ? "Archived Explorations" : "Browse Explorations"}
          </h2>
          <p style={{ color: "var(--muted-foreground)" }}>
            {archived
              ? "View archived explorations."
              : "View all explorations."}
          </p>
        </VStack>
        <ArchiveToggleButton />
      </HStack>
      {loading.loadExplorations ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: "1rem",
          }}
        >
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} style={{ height: "240px", width: "100%" }} />
          ))}
        </div>
      ) : explorations.explorations.length < 1 ? (
        <Empty style={{ borderColor: "var(--secondary-border)" }}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <BookOpen />
            </EmptyMedia>
            <EmptyTitle>
              {archived
                ? "No Archived Explorations"
                : "No Explorations Found"}
            </EmptyTitle>
            <EmptyDescription>
              {archived
                ? "There are no archived explorations."
                : "There were no explorations found, if you believe this is an error, please refresh."}
            </EmptyDescription>
          </EmptyHeader>
          {!archived && (
            <EmptyContent>
              <Button asChild style={{ textDecoration: "none" }}>
                <Link to="/explorations/me">
                  <BookOpen /> Go To My Explorations
                </Link>
              </Button>
            </EmptyContent>
          )}
        </Empty>
      ) : (
        <BrowseExplorations data={explorations} />
      )}
    </Dashboard>
  );
};

export default TeacherBrowseExplorations;
